module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2017 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2017")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("26 25 24 23 22 21 20 19 18 17    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("ISBN-13: 978-0-226-06381-2 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-06395-9 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ISBN-13: 978-0-226-06400-0 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("DOI: 10.7208/chicago/9780226064000.001.0001")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Bill Russell’s “Epitaph for the Sexual Revolution” is reprinted with permission from Samuel French, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Portions of the research presented in this book first appeared in Richard A. McKay, “‘Patient Zero’: The Absence of a Patient’s View of the Early North American AIDS Epidemic,” "), _c('i', [_vm._v("Bulletin of the History of Medicine")]), _vm._v(" 88, no. 1 (Spring 2014): 161–94, © 2014 The Johns Hopkins University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("Interviews listed in the appendix are from Richard A. McKay, 2007 and 2008, Imagining Patient Zero: Interviews about the History of the North American AIDS Epidemic, © Richard A. McKay and The British Library, Reference C1491.")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Names: McKay, Richard Andrew, 1978– author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Patient zero and the making of the AIDS epidemic / Richard A. McKay.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago : The University of Chicago Press, 2017. | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: LCCN 2017018054 | ISBN 9780226063812 (cloth : alk. paper) | ISBN 9780226063959 (pbk. : alk. paper) | ISBN 9780226064000 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: LCSH: aids (Disease)—North America—History. | Epidemics—North America. | AIDS (Disease)—North America—Historiography. | Dugas, Gaétan, 1952–1984. | AIDS (Disease)—Patients.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: LCC RA643.86.N7 M46 2017 | DDC 362.19697/920097—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("LC record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2017018054",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2017018054")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of ANSI/NISO Z39.48–1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7758e322","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-mckay-0004.vue
// module id = 63
// module chunks = 0